import React from 'react';
import { Typography } from 'antd';
import { Prism, SyntaxHighlighterProps } from 'react-syntax-highlighter';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism';

const { Paragraph } = Typography;

interface CodeBlockProps {
  language: string;
  code: string;
}
const SyntaxHighlighter = Prism as any as React.FC<SyntaxHighlighterProps>;

const CodeBlock: React.FC<CodeBlockProps> = ({ language, code }) => (
  <SyntaxHighlighter
    language={language}
    style={vscDarkPlus}
    customStyle={{
      borderRadius: '0.375rem',
    }}
  >
    {code}
  </SyntaxHighlighter>
);

interface CodeItem {
  [key: string]: string;
}

interface GenericSyntaxHighlighterProps {
  activeLang: string;
  codeData: CodeItem[];
  titles: string[];
}

const CodeHighlighter: React.FC<GenericSyntaxHighlighterProps> = ({
  activeLang,
  codeData,
  titles,
}) => {
  return (
    <>
      {codeData.map((item, index) => (
        <React.Fragment key={index}>
          <Paragraph strong>{titles[index]}</Paragraph>
          <CodeBlock language={activeLang} code={item[activeLang]} />
          {index < codeData.length - 1 && <br />}
        </React.Fragment>
      ))}
    </>
  );
};

export default CodeHighlighter;
